import * as React from 'react';
import LocalStorage from '../service/localstorage';
import UnAuthorized from './errorPages/unauthorized';
import Auth from './common/auth';
import { Tasks } from './common/auth';
import service from '../service/apolloclient.service';
import { Card, Row, Col, Button, Breadcrumb, Modal, Icon, Dropdown, Menu, message } from 'antd';
import { Route } from 'react-router-dom';
import CustomerAdd from './customer/CustomerAdd';
import CustomerList from './customer/CustomerList';
import strings from '../eyeguide-localization/customer/strings.customer';
import Util from './common/utils';
import { Link } from 'react-router-dom';
import Comparator from './common/comparer';
import Print from './common/print';
import Export from './common/export';
import CustomerFilter from './customer/CustomerFilter';
import { IcommonProps } from './common/props';
import { MSGDISPLAYTIME } from './common/constants';
import { staticProperties, STATICKEYS }  from './common/staticProperties';
import { VIEWSTATE } from './common/constants';
import CustomerEdit from './customer/CustomerEdit';
import '../css/Customer.scss';
import Token from './common/token';
import Constants from './common/constants';

const LISTDROPDOWNTEXT = {
    0: strings.lsInactiveOrgTxt,
    1: strings.lsActiveOrgTxt,
    2: strings.lsAllOrgTxt
};
const storage = new LocalStorage();
const VIEWS = {
    CUSTOMERLIST: 'list',
    ADDCUSTOMER: '/customer/add',
    EDITCUSTOMER: '/customer/edit/'
};

interface ICustomersProps extends IcommonProps {
    navigateFrom: any;
    notifyOrgStatusChange: any;
    match: any;
    location: any;
    notifyCustomerUpdate: any;
}

interface ICustomersState {
    origCustomers: any;
    customers: any;
    isFocusUser: boolean;
    loading: boolean;
    emptyText: string;
    customersAddEditTitile: string;
    printModalVisible: boolean;
    exportModalVisisble: boolean;
    modalVisible: boolean;
    filterObj: any;
    prevFilterObj: any;
    listActiveBit: number;
    view: string;
    breadCrumbValue: string;
    showOrgList: boolean;
    customerBtnText: string;
    subOrgs: any;
    subOrgListText: string;
    canViewCustomer: boolean;
    subOrgLoading: boolean;
}

export default class Customers extends React.Component <ICustomersProps, ICustomersState> {
    iframe: HTMLIFrameElement | null;

    menu = (
        <Menu onClick={() => this.exportFile()}>
          <Menu.Item key="1">{strings.lsCSVTxt}</Menu.Item>
        </Menu>
    );
    constructor(props: ICustomersProps) {
        super(props);
        let roleid: number = parseInt(Token.decodeToken().roleid, 10);
        this.state = {
            isFocusUser: Auth.canPerformTask(roleid, Tasks.isFocusUser),
            origCustomers: [],
            customers: [],
            loading: true,
            emptyText: '',
            view: VIEWS.CUSTOMERLIST,
            customersAddEditTitile: strings.lsManageOrgTxt,
            printModalVisible: false,
            exportModalVisisble: false,
            modalVisible: false,
            filterObj: [],
            prevFilterObj: [],
            listActiveBit: 1,
            breadCrumbValue: strings.lsOrgsTxt,
            showOrgList: true,
            customerBtnText: LISTDROPDOWNTEXT['1'],
            subOrgs: new Map(),
            subOrgListText: '',
            canViewCustomer: Auth.canPerformTask(roleid, Tasks.canViewCustomer),
            subOrgLoading: true
        };
        this.handleOrgActivation = this.handleOrgActivation.bind(this);
        this.getSubOrganizations = this.getSubOrganizations.bind(this);
        this.changeFilter = this.changeFilter.bind(this);
        this.notifyCustomerUpdate = this.notifyCustomerUpdate.bind(this);
        
    }

    render() {
        if (!this.state.isFocusUser || !this.state.canViewCustomer) {
            return (
                <UnAuthorized/>
            );
        } else {
            return(
                <div> 
                    <Route
                        path={VIEWS.ADDCUSTOMER} 
                        render={(props: any) => 
                            <CustomerAdd
                                save=""
                                cancel=""
                                notifyCustomerUpdate={this.notifyCustomerUpdate}
                                // organizationName={this.props.organizationName}
                                // enableTitleSpace={this.props.enableTitleSpace}
                                // organizationID={this.props.organizationID} 
                                // rosterID=""
                                // navigationFrom={this.state.navigationFrom}
                                {...props}
                            />                 
                        }
                    />
                    <Route
                        path={VIEWS.EDITCUSTOMER + ':orgid'} 
                        render={(props: any) => 
                            <CustomerEdit
                                save=""
                                cancel=""
                                notifyCustomerUpdate={this.notifyCustomerUpdate}
                                // organizationName={this.props.organizationName}
                                // enableTitleSpace={this.props.enableTitleSpace}
                                // organizationID={this.props.organizationID} 
                                // rosterID=""
                                // navigationFrom={this.state.navigationFrom}
                                {...props}
                            />                 
                        }
                    />
             {   
            this.ifRouteExists(this.props) ? '' :
            <div id="Customer" className="Customer">
            <Card >
                <Breadcrumb>
                    <Breadcrumb.Item><a href="/dashboard">{strings.lsHomeTxt}</a></Breadcrumb.Item>
                    <Breadcrumb.Item>{strings.lsOrgsTxt}</Breadcrumb.Item>
                </Breadcrumb>
                 <br/>
                <h3>{this.state.customersAddEditTitile} </h3>
            </Card>
            <div className="contentWithoutTitle">
                <Card className="filterCard">
                    <span 
                        className="filterIcon"
                        onClick={e => {
                            console.log('clicked');
                            this.setState({
                                modalVisible: true
                            });
                         }}
                    >
                    <Icon 
                        type="filter" 
                        style={{fontSize: 19, float: 'right'}}
                    />
                    </span>
                    <span style={{'fontSize': '14px', 'fontWeight': 'normal'}}>
                       <span hidden={this.checkIfFilterExists('', true)}>
                            {strings.lsNoFilterTxt}
                        </span>
                        <div className="filterContent" hidden={!this.checkIfFilterExists('', true)}>
                            <Button 
                                className="clearFilter" 
                                onClick={e => {
                                    this.clearFilters();
                                }}
                            >
                                {strings.lsClearFilterTxt}
                            </Button>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('name')}>
                                <Col span={7}>{strings.lsNameTxt}:</Col> 
                                <Col span={15}> {this.getFilterValues('name')} </Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactfirstname')}>
                                <Col span={7}>{strings.lsContactFirstNameTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactfirstname')}</Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactlastname')}>
                                <Col span={7}>{strings.lsContactLastNameTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactlastname')}</Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactphone')}>
                                <Col span={7}>{strings.lsContactPhoneTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactphone')} </Col>
                            </Row>
                            <Row className="filterRow" hidden={this.checkIfFilterExists('contactemail')}>
                                <Col span={7}>{strings.lsContactEmailTxt}:</Col>
                                <Col span={15}>{this.getFilterValues('contactemail')}</Col>
                            </Row>
                        </div>
                    </span>

                </Card>                   
                <Card 
                    title={strings.lsManageOrgTxt}
                    bordered={false}
                    className="card"
                >
                    <Link
                        to={VIEWS.ADDCUSTOMER}
                    >
                        <Button         
                            type="primary" 
                            icon="plus-circle-o"
                            onClick={e => { 
                                this.setState({ view: VIEWS.ADDCUSTOMER,  customersAddEditTitile: 'Add Customer', 
                                breadCrumbValue: 'Add', showOrgList: false});

                            }}
                        >{strings.lsAddOrgTxt}
                        </Button>   
                    </Link>
                    <Dropdown 
                        trigger={['click']}
                        overlay={this.menu}
                        getPopupContainer={this.getContainer}
                    ><Button className="downloadBtn"> 
                        {strings.lsDwnldTxt} <Icon type="down" style={{ fontSize: 10}}/> </Button>
                    </Dropdown>
                    <Modal
                        title={strings.lsExportOrgTxt}
                        visible={this.state.exportModalVisisble}
                        onOk={() => this.setState({exportModalVisisble: false})}
                        okText={strings.lsOkTxt}
                        width={450}
                        bodyStyle={{padding: 0 }}
                        maskClosable={false}
                        closable={false}
                        footer={[
                            <Button 
                                    key="Ok" 
                                    type="primary"  
                                    onClick={() => this.setState({exportModalVisisble: false})}
                            >
                            {strings.lsOkTxt}
                            </Button>,
                        ]}
                    >
                    <Row style={{padding: '19px'}}>
                        {strings.lsExportOrgSuccessTxt}
                    </Row>
                    </Modal>
                    <Button 
                        style={{marginLeft: 10, marginBottom: 20, float: 'right'}}
                        onClick={() => this.printList()}
                    >{strings.lsPrintTxt}
                    </Button>           
                    <iframe 
                        style={{height: 0, width: 0, border: 'none'}} 
                        ref={el => this.iframe = el} 
                    /> 
                    <Dropdown 
                        trigger={['click']}
                        overlay={
                            <Menu  onClick={(e: any) => this.changeListDisplay(e)}>
                                <Menu.Item key="0">
                                {LISTDROPDOWNTEXT['0']}
                                {this.state.listActiveBit === Constants.getActivitBit().INACTIVE ?
                                    <Icon 
                                        type="check" 
                                        style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}}
                                    />
                                                : ''}
                                </Menu.Item>
                                <Menu.Item key="1">{LISTDROPDOWNTEXT['1']}
                                {this.state.listActiveBit === Constants.getActivitBit().ACTIVE ?
                                    <Icon 
                                        type="check" 
                                        style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}} 
                                    /> 
                                                : ''}
                                </Menu.Item>
                                <Menu.Item key="2">{LISTDROPDOWNTEXT['2']}
                                {this.state.listActiveBit === Constants.getActivitBit().ALL ?
                                    <Icon 
                                        type="check" 
                                        style={{ fontSize: 16, color: 'green', paddingLeft: '3px'}} 
                                    /> 
                                                : ''}
                                </Menu.Item>
                            </Menu>}
                          
                        getPopupContainer={this.getContainer}
                    >   
                        <Button className="downloadBtn"> 
                            {this.state.customerBtnText} 
                            <Icon type="down" style={{ fontSize: 10, paddingRight: '7px'}}/> 
                        </Button>
                    </Dropdown>
                    <CustomerList
                        organizationID={this.props.organizationID} 
                        rosterID={this.props.rosterID} 
                        organizationName={this.props.organizationName}
                        enableTitleSpace={this.props.enableTitleSpace}
                        orgs={this.state.customers}
                        notifyActiveClick={this.handleOrgActivation}
                        loading={this.state.loading}
                        emptyText={this.state.emptyText}
                        notifyShowSubsClicked={this.getSubOrganizations}
                        subOrgs={this.state.subOrgs}
                        subOrgLoading={this.state.subOrgLoading}
                        subOrgListText={this.state.subOrgListText}
                    />                      
                </Card>
            </div>
            <Modal 
                className="modal"
                title={strings.lsOrgFilterTxt}
                visible={this.state.modalVisible}
                okText={strings.lsFilterTxt}
                onOk={() => this.setModalVisible(1)}
                onCancel={() => this.setModalVisible(0)}
                width={1000}
                bodyStyle={{padding: 0 }}
                maskClosable={false}
                closable={false}
                destroyOnClose={true}
            >   
                <CustomerFilter 
                    filterObj={this.state.filterObj}
                    notifyChangeFilter={this.changeFilter}
                />                       
            </Modal>

            </div>}
                </div>
            );
        }
    }

    componentDidMount() {
        // console.log('history', this.props.location.state);
        Util.resetScroll();
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.CUSTOMER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        if (this.state.isFocusUser) {
            if (storage.getSelectedOrgName() !== '') {
                this.logoutFromOrg();
            }
        }
        this.initializeOrgList(this.state.listActiveBit);
    }

    // componentWillReceiveProps(nextProps: any) {
    //     Utils.resetScroll();
    //     staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.CUSTOMER);
    //     staticProperties.set(STATICKEYS.selectedRoster, '');
    //     this.initializeOrgList(this.state.listActiveBit);
    // }

    /**
     * Logs out from Logged in organization.
     */
    private logoutFromOrg() {
        storage.setSelectedOrg('');      storage.setSelectedOrg('');
        storage.setSelectedOrgName('');
        storage.setSelectedOrgPrimary('');
        window.location.href = '/dashboard' ;
    }

    // private setCounts(orgs: any) {
    //     let counts: any = [];
    //     let ser = new service();
    //     let apiCalls: any = [];
    //     orgs.forEach(org => {
    //         apiCalls.push(ser.getDashboardCounts(org.organizationid));
    //     });
    //     Promise.all(apiCalls).then((res: any) => {
    //         counts = res.flat();
    //         console.log('counts', counts);
    //     });
    // }

    /**
     * Fetches the list of organizations from server
     */
    private async initializeOrgList(activeBit: number) {
        console.log('initializeOrgList called');
        let ser = new service();
        // orgs = await ser.getPrimaryOrganizations(activeBit);
        // let customerids = orgs.map((org) => org.organizationid);
        let res = await ser.getOrgsWithCounts(activeBit);
        let customers = res.filter(c => {
            return activeBit > 1 ? true : c.active === activeBit;
        });
        console.log('customers', customers);
        this.setState({
            origCustomers: res,
            customers,
            loading: false,
            emptyText: res.length === 0 ? 'No data' : '',
            subOrgs: new Map()
        });
        this.filterList();
    }

    /**
     * Clears filter array which is used fo displaying and filtering data
     */
    private clearFilters() {
        this.initializeOrgList(this.state.listActiveBit);
        this.setState({
            filterObj: [],
            prevFilterObj: []
        });
    }

    /**
     * Gets the value of property for which filter is applied
     * @param key Property for which filter is to be applied
     */
    private getFilterValues(key: string): string {
        return this.state.prevFilterObj[key];  
     }

    /**
     * Checks if any filter exists or for a particular property
     * @param property Filter property
     * @param chkIfFiltered If true, checks if any filter exists at all. 
     * If false, property is checked for existence
     */
    private checkIfFilterExists(property: string, chkIfFiltered: boolean = false): boolean {
        if (chkIfFiltered) {
            console.log('isObjectEmpty', Util.isObjectEmpty(this.state.filterObj));
            return Util.isObjectEmpty(this.state.filterObj) === true ? false : true;
        } else if (Util.isObjectEmpty(this.state.filterObj) === false) {
            console.log('isObjectEmptyElse', Util.isObjectEmpty(this.state.filterObj));
            let value = this.getFilterValues(property);
            if (value === '' || value === undefined) { return true; } else { return false; }
        } else {
            return true;
        }
    }

    /**
     * Closes the filter modal and performs tasks as per the event
     * @param event Cancel/ Filter click
     */
    private setModalVisible(event: number) {
        if (event === 1) {// filter click
             this.filterList();
        } else { // cancel click
            this.setState({filterObj: {...this.state.prevFilterObj}});
        }
        this.setState({
            modalVisible: false,
        });
    }

    /**
     * Assigns filters set through filter component
     * @param filterObj Filter Object sent by filter component
     */
    private async changeFilter(filterObj: any) {
        console.log('changeFilter', filterObj);
        this.setState({ filterObj: filterObj });
    }

    /**
     * Filters the list using the filter object created
     */
    private filterList() {
        console.log('filterObj', this.state.filterObj);
        console.log('customers', this.state.origCustomers);
        let filterObject = this.state.filterObj;
        let filteredOrgs = this.state.customers.filter(function(obj: any[]) {
            let matched = false;   
            let comp: Comparator;
            comp = new Comparator();
            matched = comp.compare(filterObject, obj);
            // console.log('comparator', matched);
            if (matched) {
                return true;
            } else {
                return false;
            }
        });
        console.log('filteredOrgs', filteredOrgs);
        this.setState({customers: filteredOrgs, prevFilterObj: {...this.state.filterObj}});
    }

    /**
     * Builds export data and calls export util
     */
    private async exportFile() {
        console.log('orgsForPrint', this.state.customers);
        let buildData: any;
        buildData = this.buildCustomerData(this.state.customers);
        if (buildData.length > 0) {
            Export.exportCSVFile(buildData, strings.lsOrgsTxt);
            this.setState({exportModalVisisble: true});
        }
    }

    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => {
        return triggernode.parentNode;
    }

    /**
     * This function builds the data required by the Table component to display the orgs
     * @param orgs Organization array containing the orgs to be dispalyed
     */
    private buildCustomerData(orgs: Array<any>) {
        let columnData: Array<any> = [];
        orgs.forEach( (element: any) => {
            let data: any = {};
            data.name = element.name;
            data.profiles = element.totalAthletes;
            data.tests = element.totalTests;
            data.baselines = element.totalBaselines;
            columnData.push(data);
        }); 
        return columnData;
    }

    /**
     * Builds print data and calls export util
     */
    private async printList() {
        console.log('OrgsFromPrint', this.state.customers);
        let buildData: any;
        buildData = this.buildCustomerData(this.state.customers);
        console.log('buildData', buildData);
        if (buildData.length > 0) {
            Print.printContents(buildData, strings.lsOrgsTxt, this.iframe);
        }
    }

    /**
     * Handles the change of organization list when toggled between active/inactive/all
     * @param menuObj Menu Object that is clicked
     */
    private changeListDisplay(menuObj: any) {
        console.log('changeList', menuObj);
        // let customers = [...this.state.origCustomers];
        let activeBit = parseInt(menuObj.key, 10);
        let customers = this.state.origCustomers.filter(c => {
            return activeBit > 1 ? true : c.active === activeBit;
        });
        console.log('customers', customers);
        this.setState(
            {
                customers,
                customerBtnText: LISTDROPDOWNTEXT[menuObj.key],  
                listActiveBit: activeBit,
                subOrgs: new Map()
            },
            () => this.filterList()
        );
    }

    /**
     * Changes organization activation as per the active bit.
     * @param activeBit Active/InActive bit to set to the org. 0 - Inactive, 1 - Active
     * @param orgId Organization id.
     */
    private async handleOrgActivation(activeBit: number, orgId: string, record: any) {
        console.log('handleOrgActivation', activeBit);
        let orgObj: any = {
            active: activeBit,
            name: record.name
        };
        let ser = new service();
        let orgResponse: any = await ser.updateSubOrganization(orgObj, orgId);
        console.log(orgResponse);
        let msgTerm: string = activeBit === 0 ? strings.lsDeactivateTxt : strings.lsActivateTxt;
        message.success(strings.formatString(strings.lsCustomerActivationSuccessTxt, msgTerm),
                        MSGDISPLAYTIME);   
        this.notifyCustomerUpdate();

    }

    /**
     * Checks the URL hit for other internal URL s
     * @param props Component Props
     */
    private ifRouteExists(props: any) {
        let exists = false;
        [VIEWS.ADDCUSTOMER, VIEWS.EDITCUSTOMER].forEach((e: string) => {
            exists = props.location.pathname.startsWith(e) || exists;
        });
        return exists;
    }

    private async getSubOrganizations(orgid: string) {
        let ser = new service(); 
        let subOrgs: any = await ser.getSuborgsWithCounts(1, orgid);
        console.log('getSubOrganizations', subOrgs);
        if (subOrgs.length > 0) {
            subOrgs = this.sortOrganizations(subOrgs);
        }
        let subOrgMap = this.state.subOrgs;
        subOrgMap.set(orgid, subOrgs);
        this.setState({
            subOrgs: subOrgMap,
            subOrgListText: subOrgs.length === 0 ? 'No Data' : '',
            subOrgLoading: false
        });
    }

    private sortOrganizations(subOrgs: any) {
        let orgs: any = [...subOrgs];
        let primeIndex: number = 0;
        let primeOrg = subOrgs.filter((e: any, index: number) => {
            if (e.isprimary === true) {
                primeIndex = index;
                return true;
            } else {
                return false;
            }
  
        });
        if (primeOrg.length > 0) {
            orgs.splice(primeIndex, 1);
            console.log('organization spliced ', orgs);
            orgs.unshift(primeOrg[0]);
        }
        return orgs;

    }
        
    /**
     * Notifies Main component to refresh Login As lists orgs
     */
    private notifyCustomerUpdate() {
        console.log('Customer notifyCustomerUpdate');
        this.props.notifyCustomerUpdate();
        this.initializeOrgList(this.state.listActiveBit); 
    }
        
}


// WEBPACK FOOTER //
// ./src/components/Customers.tsx